import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import FloatingBackButton from './FloatingBackButton';
import { ABOUT_CONTENT } from '../data/aboutContent';

import { EmojiText } from './common/Picto';
const About: React.FC = () => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const c = ABOUT_CONTENT[i18n.language === 'en' ? 'en' : 'fr'];

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <FloatingBackButton
        onBack={() => navigate(-1)}
        mode="inline"
        variant="with-text"
        text={c.backLabel}
        className="mb-6"
      />

      <h1 className="text-3xl font-bold mb-8 text-gray-900">
        {c.pageTitle}
      </h1>

      <div className="prose prose-lg max-w-none">

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800">{c.whatIsTitle}</h2>
          <p className="mb-4 text-gray-700 leading-relaxed">
            {c.whatIsP1}
          </p>
          <p className="mb-4 text-gray-700 leading-relaxed">
            {c.whatIsP2}
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800">{c.languagesTitle}</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '1rem' }}>
            {c.languages.map((lang, i) => (
              <div key={i} style={{ border: '1px solid var(--border-subtle)', borderRadius: '12px', padding: '1rem' }}>
                <div style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}><EmojiText text={lang.flag} /> <strong>{lang.name}</strong></div>
                <p style={{ margin: '0 0 0.25rem', color: '#6b7280', fontSize: '0.9rem' }}>{lang.country} · {lang.speakers}</p>
                <p style={{ margin: 0, color: '#374151', fontSize: '0.9rem', fontStyle: 'italic' }}>{lang.example}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800">{c.learnTitle}</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: '1rem' }}>
            {c.features.map((f, i) => (
              <div key={i} style={{ border: '1px solid var(--border-subtle)', borderRadius: '12px', padding: '1rem' }}>
                <div style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}><EmojiText text={f.icon} /> <strong>{f.title}</strong></div>
                <p style={{ margin: 0, color: '#6b7280', fontSize: '0.9rem', lineHeight: '1.5' }}>{f.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800">{c.statsTitle}</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '1rem', textAlign: 'center' }}>
            {c.stats.map((s, i) => (
              <div key={i} style={{ border: '1px solid var(--border-subtle)', borderRadius: '12px', padding: '1.25rem 0.5rem' }}>
                <div style={{ fontSize: '2rem', fontWeight: 800, color: '#b45309' }}>{s.number}</div>
                <div style={{ fontSize: '0.8rem', color: '#6b7280', marginTop: '0.25rem' }}>{s.label}</div>
              </div>
            ))}
          </div>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800">{c.contactTitle}</h2>
          <p className="text-gray-700 leading-relaxed">
            {c.contactText}{' '}
            <a href="mailto:jogolinga@gmail.com" className="text-blue-600 hover:underline">jogolinga@gmail.com</a>
          </p>
        </section>

      </div>
    </div>
  );
};

export default About;
